/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module APP REDUCER
 */

import {
  createReducer
} from "@reduxjs/toolkit";
import _, {
  filter,
  find,
  forEach,
  get,
  groupBy,
  includes,
  lowerCase,
  map,
  startsWith,
  toLower
} from "lodash";
import {
  browseAllStations,
  browseOwnCompanyStations,
  browseOwnStations,
  browseRepositories,
  browseStationsV2,
  getAllHardWare,
  getAllMenu,
  getAllStation,
  getStrictedRoute,
  getUserStation
} from "./actions";
import {
  SET_LIST_SERVER,
  STATION_TYPE
} from "./constants";
// State mặc định
export const defaultState = {
  repositories: {},
  listMenu: [],
  listStrictedRoute: [],
  allStations: [],
  ownStations: [],
  listStation: [],
  listHardware: [],
  provinces: {
    1: {
      name: "Hà Nội",
      region: 10
    },
    126: {
      name: "TP Hồ Chí Minh",
      region: 30
    },
    129: {
      name: "Đà Nẵng",
      region: 20
    },
    130: {
      name: "Sơn La",
      region: 10
    },
    132: {
      name: "Yên Bái",
      region: 10
    },
    134: {
      name: "Lạng Sơn",
      region: 10
    },
    135: {
      name: "Hải Phòng",
      region: 10
    },
    137: {
      name: "Tuyên Quang",
      region: 10
    },
    143: {
      name: "Quảng Trị",
      region: 20
    },
    144: {
      name: "Bắc Giang",
      region: 10
    },
    805: {
      name: "Hải Dương",
      region: 10
    },
    806: {
      name: "Cần Thơ",
      region: 30
    },
    807: {
      name: "Hà Nam",
      region: 10
    },
    808: {
      name: "Lào Cai",
      region: 10
    },
    811: {
      name: "Nam Định",
      region: 10
    },
    812: {
      name: "Bình Thuận",
      region: 30
    },
    816: {
      name: "Hưng Yên",
      region: 10
    },
    818: {
      name: "Quảng Bình",
      region: 20
    },
    819: {
      name: "Quảng Ninh",
      region: 10
    },
    821: {
      name: "Nghệ An",
      region: 20
    },
    823: {
      name: "Đồng Nai",
      region: 30
    },
    824: {
      name: "Tiền Giang",
      region: 30
    },
    826: {
      name: "Bình Định",
      region: 20
    },
    827: {
      name: "Vĩnh Phúc",
      region: 10
    },
    830: {
      name: "Hà Giang",
      region: 10
    },
    831: {
      name: "Khánh Hòa",
      region: 20
    },
    833: {
      name: "An Giang",
      region: 30
    },
    834: {
      name: "Bà Rịa - Vũng Tàu",
      region: 30
    },
    835: {
      name: "Bắc Kạn",
      region: 10
    },
    836: {
      name: "Bạc Liêu",
      region: 30
    },
    837: {
      name: "Bắc Ninh",
      region: 10
    },
    838: {
      name: "Bến Tre",
      region: 30
    },
    839: {
      name: "Bình Dương",
      region: 30
    },
    840: {
      name: "Bình Phước",
      region: 30
    },
    841: {
      name: "Cà Mau",
      region: 30
    },
    842: {
      name: "Cao Bằng",
      region: 10
    },
    843: {
      name: "Đắk Lắk",
      region: 20
    },
    844: {
      name: "Đắk Nông",
      region: 20
    },
    845: {
      name: "Điện Biên",
      region: 10
    },
    846: {
      name: "Đồng Tháp",
      region: 30
    },
    847: {
      name: "Gia Lai",
      region: 20
    },
    848: {
      name: "Hà Tĩnh",
      region: 20
    },
    849: {
      name: "Hậu Giang",
      region: 30
    },
    850: {
      name: "Hòa Bình",
      region: 10
    },
    851: {
      name: "Kiên Giang",
      region: 30
    },
    852: {
      name: "Kon Tum",
      region: 20
    },
    853: {
      name: "Lai Châu",
      region: 10
    },
    854: {
      name: "Lâm Đồng",
      region: 30
    },
    855: {
      name: "Long An",
      region: 30
    },
    856: {
      name: "Ninh Bình",
      region: 10
    },
    857: {
      name: "Ninh Thuận",
      region: 30
    },
    858: {
      name: "Phú Thọ",
      region: 10
    },
    859: {
      name: "Quảng Nam",
      region: 20
    },
    860: {
      name: "Quảng Ngãi",
      region: 20
    },
    861: {
      name: "Sóc Trăng",
      region: 30
    },
    862: {
      name: "Tây Ninh",
      region: 30
    },
    863: {
      name: "Thái Bình",
      region: 10
    },
    864: {
      name: "Thái Nguyên",
      region: 10
    },
    865: {
      name: "Thanh Hóa",
      region: 20
    },
    866: {
      name: "Thừa Thiên Huế",
      region: 20
    },
    867: {
      name: "Trà Vinh",
      region: 30
    },
    868: {
      name: "Vĩnh Long",
      region: 30
    },
    869: {
      name: "Phú Yên",
      region: 20
    }
  },
  listProvince: [],
  regions: {
    10: "Miền Bắc",
    20: "Miền Trung",
    30: "Miền Nam",
    40: "Xe Thuê"
  },
  roles: {
    1: "admin",
    2: "subadmin",
    3: "mod",
    4: "user"
  },
  printerType: {
    "1": {
      id: "1",
      name: "Bluetooth"
    },
    "0": {
      id: "0",
      name: "Wifi"
    }
  },
  printerStatus: {
    "0": {
      id: "0",
      name: "Bỏ"
    },
    "1": {
      id: "1",
      name: "Hỏng"
    },
    "2": {
      id: "2",
      name: "Đã sửa"
    },
    "3": {
      id: "3",
      name: "Đang sử dụng"
    },
    "4": {
      id: "4",
      name: "Ngưng sử dụng"
    }
  },
  listStationTreeData: [],
  listUserStationTreeData: [], //list không có region xe thuê
  listUserCompanyStationTreeData: [], //list có cả region thường + region xe thuê
  listUserCompanyOnlyTreeData: [], //list chỉ có region xe thuê
  listStationFromAdmcsm: [],
  listUserStationFromAdmcsm: [],
  listUserStartLvStationFromAdmcsm: [],
  listServer: [],
  listStationsV2: [], //list all kho dạng tree
  listStationsV2Select: [] //list all kho dạng select
};
export const toTreeData = data => {
  let result = [];
  let groupedStationByRegionId = _.groupBy(data, "region");
  for (const region_id in groupedStationByRegionId) {
    if (region_id === "null") continue;
    let stationsInRegion = groupedStationByRegionId[region_id];
    let region = {
      region_id,
      region_name: _.get(defaultState.regions, region_id),
      provinces: []
    };
    let groupedStationInRegionByProvinceId = _.groupBy(
      stationsInRegion,
      "province_id"
    );
    for (const province_id in groupedStationInRegionByProvinceId) {
      let stationsInRegionInProvince =
        groupedStationInRegionByProvinceId[province_id];
      region.provinces.push({
        province_id,
        province_name: _.get(defaultState.provinces, province_id + ".name"),
        stations: stationsInRegionInProvince
      });
    }
    result.push(region);
  }
  return result;
};

export const toStationTreeData = data => {
  let treeData = [];
  let groupedStationByRegionId = groupBy(data, "region_id");
  for (const region_id in groupedStationByRegionId) {
    if (region_id === "null") continue;
    let stationsInRegion = groupedStationByRegionId[region_id];
    let region = {
      region_id,
      region_name: get(defaultState.regions, region_id),
      provinces: []
    };
    let groupedStationInRegionByProvinceId = groupBy(
      stationsInRegion,
      "province_id"
    );
    for (const province_id in groupedStationInRegionByProvinceId) {
      let stationsInRegionInProvince =
        groupedStationInRegionByProvinceId[province_id];
      let province_name = get(defaultState.provinces, province_id + ".name");
      if (province_name) {
        region.provinces.push({
          province_id,
          province_name: province_name,
          stations: stationsInRegionInProvince
        });
      }
    }
    treeData.push(region);
  }
  return treeData;
};

// ----------------
export const reducer = createReducer(defaultState, (builder) => {
  builder
    .addCase(browseRepositories.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      let repositories = {};
      for (const id_station in payload.data) {
        const repo = payload.data[id_station];
        repositories[repo.id] = {
          ...repo,
          station_type: repo.trf_level === 'kho_tong' ?
            STATION_TYPE.LIEN_VUNG : STATION_TYPE.NOI_VUNG
        };

        if (
          draff.provinces[repo.province_id] &&
          draff.provinces[repo.province_id].repositories
        ) {
          draff.provinces[repo.province_id].repositories.push(repo.id);
        } else if (draff.provinces[repo.province_id]) {
          draff.provinces[repo.province_id].repositories = [repo.id];
        }
      }

      draff.repositories = {
        ...draff.repositories,
        ...repositories
      };
      draff.listStation = toTreeData(payload.data);
      draff.listStationRaw = payload.data;
      draff.listStationRawSelect = map(payload.data, x => ({
        label: x.name,
        value: x.id,
        ref: x
      }));
      forEach(draff.provinces, (province, key) => {
        draff.listProvince.push({
          label: province.name,
          value: key
        });
      });
    })
    .addCase(browseAllStations.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      draff.allStations = payload.data;
    })
    .addCase(browseOwnStations.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      let lvStations = [];
      draff.listUserStationFromAdmcsm = map(payload.data, x => ({
        label: x.station_name,
        value: x.station_id,
        ref: x
      }));

      let treeData = [];
      let groupedStationByRegionId = groupBy(payload.data, "region_id");
      for (const region_id in groupedStationByRegionId) {
        if (region_id === "null") continue;
        let stationsInRegion = groupedStationByRegionId[region_id];
        let region = {
          region_id,
          region_name: get(draff.regions, region_id),
          provinces: []
        };
        let groupedStationInRegionByProvinceId = groupBy(
          stationsInRegion,
          "province_id"
        );
        for (const province_id in groupedStationInRegionByProvinceId) {
          let stationsInRegionInProvince =
            groupedStationInRegionByProvinceId[province_id];
          let province_name = get(draff.provinces, province_id + ".name");
          if (province_name) {
            region.provinces.push({
              province_id,
              province_name: province_name,
              stations: stationsInRegionInProvince
            });
          }
        }
        treeData.push(region);
      }

      draff.listUserStationTreeData = treeData;

      let orderLvStation = [17548, 27631, 30598, 5984, 5944, 17853];
      orderLvStation.forEach(stationId => {
        let station = find(payload.data, x => x.station_id === stationId);
        if (station) {
          let itemStation = {
            label: station.station_name,
            value: station.station_id,
            ref: station
          };
          lvStations.push(itemStation)
        }
      });

      let otherStations = map(filter(payload.data, x => !includes(orderLvStation, x.station_id)), item => ({
        label: item.station_name,
        value: item.station_id,
        ref: item
      }));

      draff.listUserStartLvStationFromAdmcsm = lvStations.concat(otherStations);
    })
    .addCase(browseOwnCompanyStations.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;

      let treeData = [];
      let groupedStationByRegionId = groupBy(payload.data, "region_id");
      for (const region_id in groupedStationByRegionId) {
        if (region_id === "null") continue;
        let stationsInRegion = groupedStationByRegionId[region_id];
        let region = {
          region_id,
          region_name: get(draff.regions, region_id),
          provinces: []
        };
        let groupedStationInRegionByProvinceId = groupBy(
          stationsInRegion,
          "province_id"
        );
        for (const province_id in groupedStationInRegionByProvinceId) {
          let stationsInRegionInProvince =
            groupedStationInRegionByProvinceId[province_id];
          region.provinces.push({
            province_id,
            province_name: stationsInRegionInProvince[0].province_name,
            stations: stationsInRegionInProvince
          });
        }
        treeData.push(region);
      }
      draff.listUserCompanyStationTreeData = treeData;
      let xeThue = find(treeData, x => x.region_id === "40");
      if (xeThue) {
        draff.listUserCompanyOnlyTreeData = xeThue.provinces;
      }
    })
    .addCase(getAllMenu.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      draff.listMenu = payload.data;
    })
    .addCase(getStrictedRoute.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      draff.listStrictedRoute = payload.data;
    })
    .addCase(getAllStation.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      draff.listStationFromAdmcsm = map(payload.data, x => ({
        label: x.station_name,
        value: x.station_id,
        ref: x
      }));

      let treeData = [];
      let groupedStationByRegionId = groupBy(payload.data, "region_id");
      for (const region_id in groupedStationByRegionId) {
        if (region_id === "null") continue;
        let stationsInRegion = groupedStationByRegionId[region_id];
        let region = {
          region_id,
          region_name: get(draff.regions, region_id),
          provinces: []
        };
        let groupedStationInRegionByProvinceId = groupBy(
          stationsInRegion,
          "province_id"
        );
        for (const province_id in groupedStationInRegionByProvinceId) {
          let stationsInRegionInProvince =
            groupedStationInRegionByProvinceId[province_id];
          let province_name = get(draff.provinces, province_id + ".name");
          if (province_name) {
            region.provinces.push({
              province_id,
              province_name: province_name,
              stations: stationsInRegionInProvince
            });
          }
        }
        treeData.push(region);
      }
      draff.listStationTreeData = treeData;
    })
    .addCase(getUserStation.SUCCESS, (draff, incomingAction) => {
      return draff;
    })
    .addCase(getAllHardWare.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      draff.listHardware = map(payload.data, x => ({
        label: x,
        value: x
      }));
    })
    .addCase(SET_LIST_SERVER, (draff, incomingAction) => {
      const { payload } = incomingAction;
      draff.listServer = map(payload, x => ({
        label: x.server_name,
        value: x.server_no,
        ref: x
      }));
    })
    .addCase(browseStationsV2.SUCCESS, (draff, incomingAction) => {
      const { payload } = incomingAction;
      draff.listStationsV2Select = map(payload.data, x => ({
        label: x.station_name,
        value: x.station_id,
        ref: x
      }));

      let treeData = [];
      let groupedStationByRegionId = groupBy(payload.data, "region_id");
      for (const region_id in groupedStationByRegionId) {
        if (region_id === "null" || +region_id === 0) continue;
        let stationsInRegion = groupedStationByRegionId[region_id];
        let region = {
          region_id,
          region_name: get(draff.regions, region_id),
          provinces: []
        };
        let groupedStationInRegionByProvinceId = groupBy(
          stationsInRegion,
          "province_id"
        );
        for (const province_id in groupedStationInRegionByProvinceId) {
          let stationsInRegionInProvince =
            groupedStationInRegionByProvinceId[province_id];
          let province_name = get(draff.provinces, province_id + ".name");
          if (province_name) {
            region.provinces.push({
              province_id,
              province_name: province_name,
              stations: stationsInRegionInProvince
            });
          }
        }
        treeData.push(region);
      }
      draff.listStationsV2  = treeData;
    });
});